import React from "react";
import { Table, Button, Space, Popconfirm, Tag } from "antd";

const ZoneTable = ({ data, loading, onEdit, onDelete }) => {

  const columns = [
    {
      title: "Zone",
      dataIndex: "name"
    },
    {
      title: "Status",
      dataIndex: "is_active",
      render: (is_active) => (
        <Tag color={is_active === 1 ? "green" : "red"}>
          {is_active === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => onEdit(record)}>
            Edit
          </Button>

          <Popconfirm
            title="Delete menu?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button danger type="link">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
    />
  );
};

export default ZoneTable;